import { dataBarChartAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBarChartAlt = /*#__PURE__*/createIcon(dataBarChartAlt)
export default IconBarChartAlt
